import { Component, Input, ViewChild } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-acciones',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './acciones.component.html',
  styleUrl: './acciones.component.less'
})
export class AccionesComponent {
  @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

  @Input() folio!: string;
  @Input() pk!: number;
  @Input() tasa!: number;
  @Input() generateMutual!: boolean;
  @Input() tipoContrato!: string;
  @Input() status_document!: string;
  mutuoUrlStatus: { [key: number]: boolean } = {};
  spinner: boolean = false;

  constructor(
    private settings: SettingsService,
  ) {}

  async verificarMutuos() {
    try {
        const response: any = await this.settings.get_query(1, `/cliente-inversionista/mutual/${this.pk}/`);
        const downloadUrl = response._body.url;

        this.mutuoUrlStatus[this.pk] = downloadUrl !== null;

        console.log(`status url ${this.pk}:`, this.mutuoUrlStatus[this.pk]);

    } catch (error) {
        console.error('Error al verificar mutuo:', error);
        this.mutuoUrlStatus[this.pk] = false;
    }
  }

  async dowloadMutuo(event: Event) {
    event.stopPropagation();
    this.spinner = true;
    try {
      const response: any = await this.settings.get_query(1, `/cliente-inversionista/mutual/${this.pk}/`);
      const downloadUrl = response._body.url;        
      window.open(downloadUrl, '_blank');

      this.menuTrigger.closeMenu();

    } catch (error) {
      console.error('Error en la solicitud para descargar el PDF:', error);
      this.spinner = false;
    } finally {
      this.spinner = false;
    }
  }
}
